import { render, staticRenderFns } from "./nav-link.vue?vue&type=template&id=30ee557a&scoped=true"
import script from "./nav-link.vue?vue&type=script&lang=js"
export * from "./nav-link.vue?vue&type=script&lang=js"
import style0 from "./nav-link.vue?vue&type=style&index=0&id=30ee557a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ee557a",
  null
  
)

export default component.exports